<!-- Barra superior -->
  <mat-toolbar color="primary" class="navbar">
      <div style="display:flex; flex-direction:column; align-items:center;">
          <img src="assets/images/logo_suriname_white.png" alt="Coinfo"
               style="height: 40px; width: 40px;" loading="lazy">
      </div>
    <span class="logo">

      <a (click)="goToHome()" style="cursor: pointer;">
        AXIS Academy
      </a>
    </span>
    <span class="spacer"></span>

    <!-- Enlaces visibles solo en escritorio -->
    <div class="nav-links">
      <button mat-button (click)="actionHome()">{{ 'LANDING.NAVBAR_TEXT_START' | translate }}
        <mat-icon>home</mat-icon>
      </button>
      <button mat-button matTooltip="{{ 'FOOTER.LINKS.ABOUT_US' | translate }}" (click)="actionAboutUs()">{{ 'FOOTER.LINKS.ABOUT_US' | translate }} 
        <mat-icon>info</mat-icon>
      </button>
      <button mat-stroked-button color="accent" (click)="actionLogin()" matTooltip="{{ 'LANDING.NAVBAR_TEXT_LOGIN' | translate }}">
        <mat-icon>login</mat-icon> {{ 'LANDING.NAVBAR_TEXT_LOGIN' | translate }}
      </button>
      <button mat-raised-button color="accent" (click)="actionRegister()" matTooltip="{{ 'REGISTER.TOOLTIP' | translate }}">
        <mat-icon>person_add</mat-icon> {{ 'LANDING.NAVBAR_TEXT_REGISTER' | translate }}
      </button>
    </div>   
  

    <div class="nav-button">
      
      <div class="example-button-row">
    <div class="example-flex-container">
      <button matMiniFab (click)="actionAboutUs()" matTooltip="{{ 'FOOTER.LINKS.ABOUT_US' | translate }}">
        <mat-icon style="margin-right: 0;">info</mat-icon>
      </button>
      <button matMiniFab (click)="actionLogin()" matTooltip="{{ 'LOGIN.TOOLTIP' | translate }}">
        <mat-icon>login</mat-icon>
      </button>
      <button matMiniFab (click)="actionRegister()" matTooltip="{{ 'REGISTER.TOOLTIP' | translate }}">
        <mat-icon>person_add</mat-icon>
      </button>
    </div>
  </div>

    </div>

    <app-language-switcher style="margin-left: 10px;"></app-language-switcher>

  </mat-toolbar>

